// Store para mantener el estado del proceso de consolidación de envíos
export default {
  namespaced: true,
  
  state: {
    // Paso 1: Envíos seleccionados
    selectedShipments: [],
    
    // Paso 2: Vehículo seleccionado
    selectedVehicle: null,
    
    // Fecha para la consolidación
    consolidationDate: '',
    
    // Control de navegación
    currentStep: 1,
    maxStepReached: 1
  },
  
  mutations: {
    SET_SELECTED_SHIPMENTS(state, shipments) {
      state.selectedShipments = shipments;
    },
    
    ADD_SHIPMENT(state, shipment) {
      const index = state.selectedShipments.findIndex(s => s.id === shipment.id);
      if (index === -1) {
        state.selectedShipments.push(shipment);
      }
    },
    
    REMOVE_SHIPMENT(state, shipmentId) {
      state.selectedShipments = state.selectedShipments.filter(s => s.id !== shipmentId);
    },
    
    CLEAR_SHIPMENTS(state) {
      state.selectedShipments = [];
    },
    
    SET_SELECTED_VEHICLE(state, vehicle) {
      state.selectedVehicle = vehicle;
    },
    
    SET_CONSOLIDATION_DATE(state, date) {
      state.consolidationDate = date;
    },
    
    SET_CURRENT_STEP(state, step) {
      state.currentStep = step;
      if (step > state.maxStepReached) {
        state.maxStepReached = step;
      }
    },
    
    RESET_CONSOLIDATION(state) {
      state.selectedShipments = [];
      state.selectedVehicle = null;
      state.consolidationDate = '';
      state.currentStep = 1;
      state.maxStepReached = 1;
    }
  },
  
  actions: {
    setSelectedShipments({ commit }, shipments) {
      commit('SET_SELECTED_SHIPMENTS', shipments);
    },
    
    addShipment({ commit }, shipment) {
      commit('ADD_SHIPMENT', shipment);
    },
    
    removeShipment({ commit }, shipmentId) {
      commit('REMOVE_SHIPMENT', shipmentId);
    },
    
    clearShipments({ commit }) {
      commit('CLEAR_SHIPMENTS');
    },
    
    setSelectedVehicle({ commit }, vehicle) {
      commit('SET_SELECTED_VEHICLE', vehicle);
    },
    
    setConsolidationDate({ commit }, date) {
      commit('SET_CONSOLIDATION_DATE', date);
    },
    
    goToStep({ commit }, step) {
      commit('SET_CURRENT_STEP', step);
    },
    
    nextStep({ state, commit }) {
      if (state.currentStep < 2) {
        commit('SET_CURRENT_STEP', state.currentStep + 1);
      }
    },
    
    previousStep({ state, commit }) {
      if (state.currentStep > 1) {
        commit('SET_CURRENT_STEP', state.currentStep - 1);
      }
    },
    
    resetConsolidation({ commit }) {
      commit('RESET_CONSOLIDATION');
    }
  },
  
  getters: {
    // Calcula el peso total de los envíos seleccionados
    totalWeight: (state) => {
      return state.selectedShipments.reduce((sum, s) => sum + (s.package_weight || 0), 0);
    },
    
    // Calcula el volumen total de los envíos seleccionados
    totalVolume: (state) => {
      return state.selectedShipments.reduce((sum, s) => {
        const length = s.package_length || 30;
        const width = s.package_width || 20;
        const height = s.package_height || 10;
        return sum + ((length * width * height) / 1000000); // cm³ a m³
      }, 0);
    },
    
    // Número de envíos seleccionados
    shipmentsCount: (state) => {
      return state.selectedShipments.length;
    },
    
    // Verifica si un shipment está seleccionado
    isShipmentSelected: (state) => (shipmentId) => {
      return state.selectedShipments.some(s => s.id === shipmentId);
    },
    
    // Verifica si se puede ir a un paso específico
    canGoToStep: (state) => (step) => {
      return step <= state.maxStepReached + 1;
    },
    
    // Verifica si el paso 1 está completo
    isStep1Complete: (state) => {
      return state.selectedShipments.length > 0;
    },
    
    // Verifica si el paso 2 está completo
    isStep2Complete: (state) => {
      return state.selectedVehicle !== null;
    }
  }
};

